import { render } from "./setps.vue?vue&type=template&id=7e01855a&scoped=true"
import script from "./setps.vue?vue&type=script&lang=js"
export * from "./setps.vue?vue&type=script&lang=js"

import "./setps.vue?vue&type=style&index=0&id=7e01855a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e01855a"

export default script